import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { Box, Grid } from '@mui/material';
import { useLogin, useNotify } from 'react-admin';
import { LoginToken } from '../../lib/Providers/Auth/GoogleAuthProvider';

const GoogleLoginPage = () => {
  const login = useLogin();
  const notify = useNotify();
  return (
    <GoogleOAuthProvider clientId="969182876986-p0m6of45sg1qqu2m6o5ic82pq5fi3n87.apps.googleusercontent.com">
      <Box style={{ paddingBottom: 20 }}>
        <Grid container spacing={2} direction="column" justifyContent="center" alignItems="center">
          <Grid item xs={2}>
            Day Admin SSO Login
          </Grid>
          <Grid item xs={2}>
            <GoogleLogin
              theme="filled_blue"
              useOneTap={false}
              size="large"
              shape="pill"
              logo_alignment="center"
              text="signin_with"
              ux_mode="popup"
              onSuccess={async (credentialResponse) => {
                if (credentialResponse.credential) {
                  login({ idToken: credentialResponse.credential } as LoginToken).catch(() => {
                    notify('Login failed..');
                  });
                }
                console.log(credentialResponse);
              }}
              onError={() => {
                notify('Login failed..');
                console.log('Login Failed');
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginPage;

//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
